export const PAYMENT_GATEWAYS = [
  { value: "All", label: "All" },
  { value: "Razorpay", label: "Razorpay" },
  { value: "Stripe", label: "Stripe" },
  { value: "In App Purchase", label: "In App Purchase" },
  { value: "Flutter Wave", label: "Flutter Wave" },
  { value: "Pay Pal", label: "Pay Pal" },
  { value: "Pay Stack", label: "Pay Stack" },
  { value: "Cash Free", label: "Cash Free" },
];

